let cachedIP: string | null = null;
let cacheTimestamp: number = 0;
const CACHE_DURATION = 5 * 60 * 1000;

export async function getClientIP(): Promise<string> {
  if (cachedIP && Date.now() - cacheTimestamp < CACHE_DURATION) {
    return cachedIP;
  }

  try {
    const response = await fetch('https://api.ipify.org?format=json', {
      signal: AbortSignal.timeout(5000),
    });

    if (response.ok) {
      const data = await response.json();
      cachedIP = data.ip;
      cacheTimestamp = Date.now();
      return cachedIP;
    }
  } catch (err) {
    console.warn('Primary IP detection failed, trying fallback');
  }

  try {
    const response = await fetch('https://ipapi.co/ip/', {
      signal: AbortSignal.timeout(5000),
    });

    if (response.ok) {
      cachedIP = await response.text();
      cacheTimestamp = Date.now();
      return cachedIP.trim();
    }
  } catch (err) {
    console.warn('Fallback IP detection failed');
  }

  return 'unknown';
}

export function clearIPCache(): void {
  cachedIP = null;
  cacheTimestamp = 0;
}

export function isValidIP(ip: string): boolean {
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6Pattern = /^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/;

  if (ipv4Pattern.test(ip)) {
    const parts = ip.split('.').map(Number);
    return parts.every(part => part >= 0 && part <= 255);
  }

  return ipv6Pattern.test(ip);
}

export function maskIP(ip: string): string {
  if (!ip || ip === 'unknown') return 'unknown';

  const parts = ip.split('.');
  if (parts.length === 4) {
    return `${parts[0]}.${parts[1]}.xxx.xxx`;
  }

  return ip.substring(0, Math.min(ip.length, 10)) + '...';
}
